import {
  Text,
  Badge,
  Link,
  Panel,
  PanelHeader,
  PanelTitle,
  PanelSection,
  InlineStack,
  Stack,
  SkeletonText,
  PanelActions,
} from '@customerio/pluma-components/react';
import type { ServicesApiTotals } from '@/services/api/services-api';
import { useAnalytics } from '@/services/analytics';

interface TotalsPanelProps {
  title: string;
  isLoading: boolean;
  totals: ServicesApiTotals | undefined;
  viewAllHref: string;
  viewAllDestination?: string;
}

export function TotalsPanel({ title, isLoading, totals, viewAllHref, viewAllDestination }: TotalsPanelProps) {
  const { track } = useAnalytics();
  const unused = totals != null ? totals.all - totals.in_use : 0;

  const handleViewAllClick = () => {
    if (viewAllDestination != null) {
      void track('workspaceHealth', 'viewAllClicked', { Destination: viewAllDestination });
    }
  };

  return (
    <Panel>
      <PanelHeader>
        <PanelTitle>{title}</PanelTitle>
        <PanelActions>
          <Link
            href={viewAllHref}
            variant="primary"
            onClick={viewAllDestination != null ? handleViewAllClick : undefined}
          >
            View all
          </Link>
        </PanelActions>
      </PanelHeader>
      <PanelSection>
        {isLoading ? (
          <SkeletonText size="s" lines={3} />
        ) : totals != null ? (
          <Stack gap="100">
            <InlineStack alignInline="space-between" alignBlock="center" py="050">
              <Text size="s">Total</Text>
              <Badge>{totals.all.toLocaleString()}</Badge>
            </InlineStack>
            <InlineStack alignInline="space-between" alignBlock="center" py="050">
              <Text size="s">Used</Text>
              <Badge>{totals.in_use.toLocaleString()}</Badge>
            </InlineStack>
            <InlineStack alignInline="space-between" alignBlock="center" py="050">
              <Text size="s">Unused</Text>
              <Badge>{unused.toLocaleString()}</Badge>
            </InlineStack>
          </Stack>
        ) : null}
      </PanelSection>
    </Panel>
  );
}
